import type { Tweaks, TweakKey, TweakValue } from "../lib/tweaks";

type TweaksPanelProps = {
  tweaks: Tweaks;
  setKey: <K extends TweakKey>(k: K, v: TweakValue<K>) => void;
};

const ACCENTS = ["#3BB0F5", "#F59E0B", "#10B981", "#A78BFA", "#EF4444"] as const;

/**
 * Live tweaks panel — toggles variant (tech/warm), language (de/en), accent
 * swatch, and serif-accents on/off. Floats in the bottom-right; mounted by
 * App when the page is opened in edit-mode from the Claude Design host.
 */
export function TweaksPanel({ tweaks, setKey }: TweaksPanelProps) {
  return (
    <aside className="tweaks">
      <div className="tweaks-head">
        <span className="tweaks-title">Tweaks</span>
        <span className="tweaks-sub">Live-Vorschau</span>
      </div>

      <div className="tweak-row">
        <div className="tweak-label">Design-Richtung</div>
        <div className="tweak-seg">
          <button
            className={tweaks.variant === "warm" ? "on" : ""}
            onClick={() => setKey("variant", "warm")}
          >
            Hell
          </button>
          <button
            className={tweaks.variant === "tech" ? "on" : ""}
            onClick={() => setKey("variant", "tech")}
          >
            Dunkel
          </button>
        </div>
      </div>

      <div className="tweak-row">
        <div className="tweak-label">Sprache</div>
        <div className="tweak-seg">
          <button
            className={tweaks.lang === "de" ? "on" : ""}
            onClick={() => setKey("lang", "de")}
          >
            DE
          </button>
          <button
            className={tweaks.lang === "en" ? "on" : ""}
            onClick={() => setKey("lang", "en")}
          >
            EN
          </button>
        </div>
      </div>

      <div className="tweak-row">
        <div className="tweak-label">Akzentfarbe</div>
        <div className="tweak-colors">
          {ACCENTS.map((c) => (
            <button
              key={c}
              className={"tweak-swatch " + (tweaks.accent === c ? "on" : "")}
              style={{ background: c }}
              onClick={() => setKey("accent", c)}
              aria-label={c}
            />
          ))}
        </div>
      </div>

      <div className="tweak-row">
        <div className="tweak-label">Serif-Akzente</div>
        <div className="tweak-seg">
          <button
            className={tweaks.serifAccents ? "on" : ""}
            onClick={() => setKey("serifAccents", true)}
          >
            An
          </button>
          <button
            className={!tweaks.serifAccents ? "on" : ""}
            onClick={() => setKey("serifAccents", false)}
          >
            Aus
          </button>
        </div>
      </div>
    </aside>
  );
}
